import { MenuItem, TextField } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { useField } from "formik";
import React from "react";
import { useCategories } from "../categories/useCategories.js";

interface Props {
  name: string;
  label: string;
  disabled?: boolean;
}

// Single select over the root categories (verticals), ordered by rank, with a
// "Please choose" entry for no vertical. Built on `TextField select` rather
// than `SelectField` so the empty entry is displayed under a shrunk label.
export function VerticalSelectField({ name, label, disabled = false }: Props) {
  const { t } = useTranslate(["ProjectCreate"]);
  const [{ value }, , { setValue }] = useField<string | null>(name);
  const { categories } = useCategories();

  const verticals = React.useMemo(
    () =>
      categories
        .filter(c => !c.parentId)
        .slice()
        .sort((a, b) => a.rank - b.rank),
    [categories]
  );

  return (
    <TextField
      select
      fullWidth
      name={name}
      label={label}
      value={value ?? ""}
      disabled={disabled}
      onChange={event => setValue(event.target.value || null)}
      slotProps={{
        select: { displayEmpty: true },
        inputLabel: { shrink: true },
      }}
    >
      <MenuItem value="">
        {t("Please choose", { ns: "ProjectCreate" })}
      </MenuItem>
      {verticals.map(vertical => (
        <MenuItem key={vertical.id} value={vertical.id}>
          {vertical.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
